import React from 'react';
import WordCloud from 'react-d3-cloud';


class SkillsCloud extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            skills: props.skills
        };
    }

    fontSizeMapper(word){
        let v = word.value;
        if (word.value === 5) {
            v = word.value * 1;
        }
        if (word.value === 2) {
            v = word.value * 10;
        }
        if (word.value === 3) {
            v = word.value * 200;
        }
        if (word.value === 4) {
            v = word.value * 1000;
        }
        return 12 + Math.log2(v) * 3
    }
    render() {
        if (typeof window !== `undefined`) {
            return (
                <div className="word-cloud">
                    <WordCloud
                        data={this.state.skills}
                        height={300}
                        fontSizeMapper={this.fontSizeMapper}
                    />
                </div>
            );   
        } else{
            return (<></>);
        }
    }
}

export default SkillsCloud;